import {injectable} from 'inversify'
import {getQueryClient} from '@/src/shared/utils/query-client'
import type {QueryCacheInterface} from '@/src/ports/services/query-cache'

/**
 * Query Cache Service Implementation
 *
 * Wraps React Query's QueryClient for cache operations.
 * Provides a clean interface for presentation layer to invalidate/update cache.
 */
@injectable()
export class QueryCacheService implements QueryCacheInterface {
  async invalidateQueries(queryKey: any[]): Promise<void> {
    const queryClient = getQueryClient()
    await queryClient.invalidateQueries({queryKey})
  }

  getQueryData<T>(queryKey: any[]): T | undefined {
    const queryClient = getQueryClient()
    return queryClient.getQueryData<T>(queryKey)
  }

  setQueryData<T>(queryKey: any[], data: T): void {
    const queryClient = getQueryClient()
    queryClient.setQueryData(queryKey, data)
  }

  isFetching(queryKey: any[]): boolean {
    const queryClient = getQueryClient()
    return queryClient.isFetching({queryKey}) > 0
  }

  subscribeToCache(callback: () => void): () => void {
    const queryClient = getQueryClient()
    return queryClient.getQueryCache().subscribe(callback)
  }
}
